import {
  hcr_addDomainReplacement,
  hcr_addHierarchyNodes,
  hcr_addSingleReplacement,
  hcr_clearHierarchy,
  hcr_loadClinicalLibrary,
  hcr_loadHierarchy,
  hcr_patchHierarchyComments,
  hcr_removeDomainReplacement,
  hcr_removeHierarchyComment,
  hcr_removeHierarchyNode,
  hcr_removeSingleReplacement,
  hcr_saveHierarchy,
  hcr_saveHierarchyCompleted,
  hcr_saveHierarchyFailed,
  hcr_saveTocMajorVersion,
  hcr_setAccessRights,
  hcr_setClinicalLibraryLoading,
  hcr_setHierarchyCommentPanel,
  hcr_setHierarchyId,
  hcr_setHierarchyNameSaveBlocker,
  hcr_setHierarchySaveRequestStatus,
  hcr_setHierarchySaveTocRequestStatus,
  hcr_setHierarchySubscriptionStatus,
  hcr_updateDomainReplacement,
  hcr_updateHierarchy,
  hcr_updateHierarchyComment,
  hcr_updateSingleReplacements,
  hcr_updateTlfItemIndex,
} from "./functions";
import {
  ADD_DOMAIN_REPLACEMENT,
  ADD_HIERARCHY_NODES,
  ADD_SINGLE_REPLACEMENT,
  CLEAR_HIERARCHY,
  HierarchyContextProps,
  IHierarchyAction,
  LOAD_CLINICAL_LIBRARY,
  LOAD_HIERARCHY,
  PATCH_HIERARCHY_COMMENTS,
  REMOVE_DOMAIN_REPLACEMENT,
  REMOVE_HIERARCHY_COMMENT,
  REMOVE_HIERARCHY_NODE,
  REMOVE_SINGLE_REPLACEMENT,
  SAVE_HIERARCHY,
  SAVE_HIERARCHY_COMPLETED,
  SAVE_HIERARCHY_FAILED,
  SAVE_TOC_MAJOR_VERSION,
  SET_ACCESS_RIGHTS,
  SET_CLINICAL_LIBRARY_LOADING,
  SET_HIERARCHY_COMMENT_PANEL,
  SET_HIERARCHY_ID,
  SET_HIERARCHY_NAME_SAVE_BLOCKER,
  SET_HIERARCHY_SAVE_REQUEST_STATUS,
  SET_HIERARCHY_SAVE_TOC_REQUEST_STATUS,
  SET_HIERARCHY_SUBSCRIPTION_STATUS,
  UPDATE_DOMAIN_REPLACEMENT,
  UPDATE_HIERARCHY,
  UPDATE_HIERARCHY_COMMENT,
  UPDATE_SINGLE_REPLACEMENT,
  UPDATE_TLF_ITEM_INDEX,
} from "./interface";

/**
 * Reducer for hierarchy context state transitions.
 *
 * @param state - The current `HierarchyContextProps` state.
 * @param action - The `IHierarchyAction` describing the change to apply.
 * @returns The updated `HierarchyContextProps` after applying the action.
 */
export const hierarchyContextReducer = (
  state: HierarchyContextProps,
  action: IHierarchyAction,
): HierarchyContextProps => {
  switch (action.operation) {
    case ADD_DOMAIN_REPLACEMENT:
      return hcr_addDomainReplacement(state, action);

    case ADD_HIERARCHY_NODES:
      return hcr_addHierarchyNodes(state, action);

    case ADD_SINGLE_REPLACEMENT:
      return hcr_addSingleReplacement(state, action);

    case CLEAR_HIERARCHY:
      return hcr_clearHierarchy(state);

    case LOAD_HIERARCHY:
      return hcr_loadHierarchy(state, action);

    case LOAD_CLINICAL_LIBRARY:
      return hcr_loadClinicalLibrary(state, action);

    case PATCH_HIERARCHY_COMMENTS:
      return hcr_patchHierarchyComments(state, action);

    case REMOVE_DOMAIN_REPLACEMENT:
      return hcr_removeDomainReplacement(state, action);

    case REMOVE_HIERARCHY_COMMENT:
      return hcr_removeHierarchyComment(state, action);

    case REMOVE_HIERARCHY_NODE:
      return hcr_removeHierarchyNode(state, action);

    case REMOVE_SINGLE_REPLACEMENT:
      return hcr_removeSingleReplacement(state, action);

    case SAVE_HIERARCHY:
      return hcr_saveHierarchy(state, action);

    case SAVE_HIERARCHY_COMPLETED:
      return hcr_saveHierarchyCompleted(state, action);

    case SAVE_HIERARCHY_FAILED:
      return hcr_saveHierarchyFailed(state);

    case SAVE_TOC_MAJOR_VERSION:
      return hcr_saveTocMajorVersion(state, action);

    case SET_CLINICAL_LIBRARY_LOADING:
      return hcr_setClinicalLibraryLoading(state, action);

    case SET_HIERARCHY_SAVE_REQUEST_STATUS:
      return hcr_setHierarchySaveRequestStatus(state, action);

    case SET_HIERARCHY_SAVE_TOC_REQUEST_STATUS:
      return hcr_setHierarchySaveTocRequestStatus(state, action);

    case SET_ACCESS_RIGHTS:
      return hcr_setAccessRights(state, action);

    case SET_HIERARCHY_COMMENT_PANEL:
      return hcr_setHierarchyCommentPanel(state, action);

    case SET_HIERARCHY_ID:
      return hcr_setHierarchyId(state, action);

    case SET_HIERARCHY_NAME_SAVE_BLOCKER:
      return hcr_setHierarchyNameSaveBlocker(state, action);

    case UPDATE_DOMAIN_REPLACEMENT:
      return hcr_updateDomainReplacement(state, action);

    case UPDATE_HIERARCHY:
      return hcr_updateHierarchy(state, action);

    case UPDATE_HIERARCHY_COMMENT:
      return hcr_updateHierarchyComment(state, action);

    case UPDATE_SINGLE_REPLACEMENT:
      return hcr_updateSingleReplacements(state, action);

    case UPDATE_TLF_ITEM_INDEX:
      return hcr_updateTlfItemIndex(state, action);

    case SET_HIERARCHY_SUBSCRIPTION_STATUS:
      return hcr_setHierarchySubscriptionStatus(state, action);
  }
};
